import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Container, Nav, NavItem, NavLink, Row, TabContent, TabPane, Table } from 'reactstrap';
import UiContent from '../../../../Components/Common/UiContent';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import ProductiveCycleActivitySection from './Sections/ProductiveCycleActivitySection';
import useRedirectEstablishmentActiveContent from '../../../../Components/Hooks/useRedirectEstablishmentActiveContent';


const EstablishmentActivities = () => {
    const location = useLocation();
    const { id } = useParams();
    const redirectEstablishmentActiveContent = useRedirectEstablishmentActiveContent('/establishment/activities/establishmentId');

    const breadcrumbLinks = [
		{ to: '#', label: 'Centro', icon: 'icon-map-pin-house' },
	];


    const [activeTab, setActiveTab] = useState("cp");
    const toggle = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Actividades' links={breadcrumbLinks} icon={'icon-hand-coins'} />
                    <ProductiveCycleActivitySection/>
				</Container>
			</div>
		</React.Fragment>
    );
};

export default EstablishmentActivities;
